module.exports = __webpack_public_path__ + "static/media/downWhite2.a75750fb.svg";